import { useNavigate } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import CTAButton from "../CTAButton";

/**
 * PortfolioCard
 * Reusable card for portfolio/project listings with tags, stats, and CTAs.
 */
const PortfolioCard = ({
  title,
  logo,
  summary,
  tags = [],
  stats = [],
  href,
  externalHref,
  className = "",
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    if (href) navigate(href);
  };

  return (
    <div
      className={`relative overflow-hidden rounded-3xl border border-black bg-white transition-all duration-200 ${className}`}
    >
      <div class="absolute -left-12 -top-12 w-32 h-32 rounded-full bg-[#F63F46]/40 blur-3xl" aria-hidden="true"></div>

      <div className="relative p-6 md:p-8 flex flex-col gap-6">
        {/* Tags */}
        {tags?.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 text-xs font-semibold rounded-full bg-slate-900 text-[#d6fa70] tracking-wide uppercase"
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="space-y-3">
          {logo ? (
            <img src={logo} alt={title} className="h-8 object-contain" />
          ) : (
            <h3 className="text-2xl md:text-3xl font-bold text-slate-900">{title}</h3>
          )}
          <p className="text-slate-600 text-lg leading-relaxed">{summary}</p>
        </div>

        {/* Stats */}
        {stats?.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="p-4 rounded-2xl  bg-slate-100"
              >
                <p className="text-sm text-slate-500">{stat.label}</p>
                <p className="text-xl font-semibold text-slate-900">{stat.value}</p>
              </div>
            ))}
          </div>
        )}

        <div className="flex flex-wrap gap-3">
          {href && (
            <CTAButton onClick={handleNavigate} icon={FiArrowUpRight}>
              View Project
            </CTAButton>
          )}
          {externalHref && (
            <a
              href={externalHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-slate-300 text-slate-800 font-semibold hover:border-slate-400 hover:text-slate-900 transition-colors"
            >
              Live product
              <FiArrowUpRight size={18} />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;
